import swiper from 'swiper';




/*---------------------------
総合トップスライド
-----------------------------*/

// var loopSwiper = new swiper('.js-swiper', {
// 	loop: true,
//   effect: 'fade',
//   speed: 5000,
// 	autoplay: {
// 		delay: 0,
// 	}
	
// });

/*---------------------------
採用トップスライド
-----------------------------*/
// var loopSwiper2 = new swiper('.js-swiper2', {
// 	loop: true,
//   effect: 'coverflow',
//   speed: 6000,
// 	autoplay: {
// 		delay: 0,
// 	}	
// });

// var loopSwiper3 = new swiper('.js-swiper3', {
// 	loop: true,
//   effect: 'coverflow',
//   speed: 6000,
// 	autoplay: {
// 		delay: 0,
// 	}	
// });